import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isEmpty, isNil, uniq } from "lodash";
import Vue from "vue";
export const SET_DOCUMENTS = "SET_DOCUMENTS";
export const SET_DOCUMENT_COMMENTS = "SET_DOCUMENT_COMMENTS";
export const SET_DOCUMENT_CLASSIFICATIONS = "SET_DOCUMENT_CLASSIFICATIONS";
export const SET_DOCUMENT_CLASSIFICATION_SENT_STATUS = "SET_DOCUMENT_CLASSIFICATION_SENT_STATUS";
export const SET_DOCUMENT_REQUEST_LISTS = "SET_DOCUMENT_REQUEST_LISTS";
export const SET_DOCUMENT_REQUESTS = "SET_DOCUMENT_REQUESTS";
export const SET_SAMPLE_DOCUMENTS = "SET_SAMPLE_DOCUMENTS";
export const SET_MARKED_DOCUMENT_CLASSIFICATION = "SET_MARKED_DOCUMENT_CLASSIFICATION";
export const CLEAR_MARKED_DOCUMENT_CLASSIFICATION = "CLEAR_MARKED_DOCUMENT_CLASSIFICATION";
export const SET_DOCUMENT_CLASSIFICATION_DESCRIPTION = "SET_DOCUMENT_CLASSIFICATION_DESCRIPTION";
export const ADD_DOCUMENT_COMMENT = "ADD_DOCUMENT_COMMENT";
export const ADD_DOCUMENT_CLASSIFICATION = "ADD_DOCUMENT_CLASSIFICATION";
export const REMOVE_DOCUMENT_COMMENT = "REMOVE_DOCUMENT_COMMENT";
export const REMOVE_DOCUMENT_CLASSIFICATION = "REMOVE_DOCUMENT_CLASSIFICATION";
export const EDIT_DOCUMENT_DETAILS = "EDIT_DOCUMENT_DETAILS";
export const ADD_DOCUMENTS_TO_CLASSIFICATION = "ADD_DOCUMENTS_TO_CLASSIFICATION";
export const REMOVE_DOCUMENT_FROM_CLASSIFICATION = "REMOVE_DOCUMENT_FROM_CLASSIFICATION";
export const SET_DOCUMENT_REQUEST_EMAIL_TEMPLATES = "SET_DOCUMENT_REQUEST_EMAIL_TEMPLATES";
export const SET_DOCUMENT_REQUEST_EMAIL_TEMPLATE = "SET_DOCUMENT_REQUEST_EMAIL_TEMPLATE";
export const SET_DOCUMENT_REQUEST_EMAIL_TEMPLATE_DETAILS = "SET_DOCUMENT_REQUEST_EMAIL_TEMPLATE_DETAILS";
export const REMOVE_DOCUMENT_REQUEST_EMAIL_TEMPLATE = "REMOVE_DOCUMENT_REQUEST_EMAIL_TEMPLATE";
export const SET_NEW_DOCUMENT_REQUEST_EMAIL_TEMPLATE = "SET_NEW_DOCUMENT_REQUEST_EMAIL_TEMPLATE";
export const SET_DOCUMENT_REQUEST_LIST = "SET_DOCUMENT_REQUEST_LIST";
export const SET_DRAFT_TEMPLATE_NAME = "SET_DRAFT_TEMPLATE_NAME";
export const SET_DOCUMENT_REQUEST_CLASSIFICATION_DESCRIPTION = "SET_DOCUMENT_REQUEST_CLASSIFICATION_DESCRIPTION";
export const REMOVE_DOCUMENT_REQUEST_CLASSIFICATION = "REMOVE_DOCUMENT_REQUEST_CLASSIFICATION";
export const ADD_DOCUMENT_REQUEST_CLASSIFICATION = "ADD_DOCUMENT_REQUEST_CLASSIFICATION";
export const EDIT_REQUEST_LIST_DOCUMENT_DETAILS = "EDIT_REQUEST_LIST_DOCUMENT_DETAILS";
export const REMOVE_DOCUMENT_FROM_REQUEST_CLASSIFICATION = "REMOVE_DOCUMENT_FROM_REQUEST_CLASSIFICATION";
export const ADD_DOCUMENT_TO_REQUEST_CLASSIFICATION = "ADD_DOCUMENT_TO_REQUEST_CLASSIFICATION";
export const ADD_DOCUMENT_REQUEST_LIST = "ADD_DOCUMENT_REQUEST_LIST";
export const EMPTY_REQUEST_LIST = "EMPTY_REQUEST_LIST";
export const DELETE_REQUEST_LIST = "DELETE_REQUEST_LIST";
export const SET_DOCUMENT_TYPES = "SET_DOCUMENT_TYPES";
export const UPDATE_DOCUMENT_TYPE = "UPDATE_DOCUMENT_TYPE";
export const REMOVE_DOCUMENT_TYPE = "REMOVE_DOCUMENT_TYPE";
export const ADD_DOCUMENT_TYPE = "ADD_DOCUMENT_TYPE";
export const SET_DOCUMENT_TYPES_ORDER = "SET_DOCUMENT_TYPES_ORDER";
export const SET_DOCUMENT_LABEL = "SET_DOCUMENT_LABEL";
export const SET_DOCUMENT_LABELS = "SET_DOCUMENT_LABELS";
export const ADD_DOCUMENT_LABEL = "ADD_DOCUMENT_LABEL";
export const DELETE_DOCUMENT_LABEL = "DELETE_DOCUMENT_LABEL";
export const DELETE_LABEL_TO_DOCUMENT = "DELETE_LABEL_TO_DOCUMENT";
export const SET_DOCUMENT_NEW_COMMENTS_NUMBER = "SET_DOCUMENT_NEW_COMMENTS_NUMBER";
export const SET_DOCUMENT_REQUESTS_ORDER = "SET_DOCUMENT_REQUESTS_ORDER";
export const SET_EXTRACTED_VALUES = "SET_EXTRACTED_VALUES";
const mutations = {
  [SET_DRAFT_TEMPLATE_NAME]: (state, {
    DRAFT_TEMPLATE_NAME
  }) => {
    state.DRAFT_TEMPLATE_NAME = DRAFT_TEMPLATE_NAME;
  },
  [SET_DOCUMENTS]: (state, {
    documents,
    applicationId
  }) => {
    Vue.set(state.documents.byApplication, applicationId, documents);
  },
  [SET_DOCUMENT_COMMENTS]: (state, {
    comments,
    applicationId
  }) => {
    Vue.set(state.comments.byApplication, applicationId, comments);
  },
  [SET_DOCUMENT_CLASSIFICATIONS]: (state, {
    classifications,
    applicationId
  }) => {
    Vue.set(state.classifications.byApplication, applicationId, classifications);
  },
  [SET_DOCUMENT_REQUEST_LISTS]: (state, {
    documentRequestLists
  }) => {
    state.documentRequestLists = documentRequestLists;
  },
  [SET_DOCUMENT_REQUESTS]: (state, {
    documentRequests
  }) => {
    state.documentRequests = documentRequests;
  },
  [SET_SAMPLE_DOCUMENTS]: (state, {
    sampleDocuments
  }) => {
    state.sampleDocuments = sampleDocuments;
  },
  [SET_MARKED_DOCUMENT_CLASSIFICATION]: (state, {
    markedDocumentClassifications
  }) => {
    state.markedDocumentClassifications = _objectSpread(_objectSpread({}, state.markedDocumentClassifications), markedDocumentClassifications);
  },
  [CLEAR_MARKED_DOCUMENT_CLASSIFICATION]: state => {
    state.markedDocumentClassifications = {};
  },
  [SET_DOCUMENT_CLASSIFICATION_DESCRIPTION]: (state, {
    applicationId,
    documentRequestId,
    description
  }) => {
    Vue.set(state.classifications.byApplication[applicationId].byId[documentRequestId], "description", description);
  },
  [SET_DOCUMENT_CLASSIFICATION_SENT_STATUS]: (state, {
    applicationId,
    documentRequestId,
    sent,
    requestedAt
  }) => {
    Vue.set(state.classifications.byApplication[applicationId].byId[documentRequestId], "sent", sent);
    Vue.set(state.classifications.byApplication[applicationId].byId[documentRequestId], "requestedAt", requestedAt);
  },
  [ADD_DOCUMENT_COMMENT]: (state, {
    applicationId,
    documentId,
    comment
  }) => {
    Vue.set(state.comments.byApplication[applicationId].byId, comment.id, comment);
    state.documents.byApplication[applicationId].byId[documentId].comments.push(comment.id);
  },
  [REMOVE_DOCUMENT_COMMENT]: (state, {
    applicationId,
    documentId,
    commentId
  }) => {
    Vue.delete(state.comments.byApplication[applicationId].byId, commentId);
    const documentComments = state.documents.byApplication[applicationId].byId[documentId].comments;
    state.documents.byApplication[applicationId].byId[documentId].comments = _filterInstanceProperty(documentComments).call(documentComments, id => id !== commentId);
  },
  [ADD_DOCUMENT_CLASSIFICATION]: (state, {
    applicationId,
    documentClassification
  }) => {
    Vue.set(state.classifications.byApplication[applicationId].byId, documentClassification.documentRequestId, documentClassification);
    state.classifications.byApplication[applicationId].allIds.push(documentClassification.documentRequestId);
  },
  [REMOVE_DOCUMENT_CLASSIFICATION]: (state, {
    applicationId,
    documentRequestId
  }) => {
    const documentClassifications = state.classifications.byApplication[applicationId].allIds;
    state.classifications.byApplication[applicationId].allIds = _filterInstanceProperty(documentClassifications).call(documentClassifications, id => id !== documentRequestId);
    Vue.delete(state.classifications.byApplication[applicationId].byId, documentRequestId);
  },
  [EDIT_DOCUMENT_DETAILS]: (state, {
    applicationId,
    document
  }) => {
    Vue.set(state.documents.byApplication[applicationId].byId, document.documentId, _objectSpread(_objectSpread({}, state.documents.byApplication[applicationId].byId[document.documentId]), document));
  },
  [ADD_DOCUMENTS_TO_CLASSIFICATION]: (state, {
    applicationId,
    documents,
    documentRequestId
  }) => {
    for (const document of documents) {
      Vue.set(state.documents.byApplication[applicationId].byId, document.documentId, document);
    }
    const documentClassification = state.classifications.byApplication[applicationId].byId[documentRequestId];
    documentClassification.documents.push(..._mapInstanceProperty(documents).call(documents, ({
      documentId
    }) => documentId));
  },
  [REMOVE_DOCUMENT_FROM_CLASSIFICATION]: (state, {
    applicationId,
    documentId,
    documentRequestId
  }) => {
    var _context;
    const documentClassification = state.classifications.byApplication[applicationId].byId[documentRequestId];
    documentClassification.documents = _filterInstanceProperty(_context = documentClassification.documents).call(_context, id => id !== documentId);
    Vue.delete(state.documents.byApplication[applicationId].byId, documentId);
  },
  [SET_DOCUMENT_REQUEST_EMAIL_TEMPLATES]: (state, documentRequestTemplates) => {
    state.documentRequestTemplates = documentRequestTemplates;
  },
  [SET_DOCUMENT_REQUEST_EMAIL_TEMPLATE]: (state, {
    html,
    templateId
  }) => {
    state.documentRequestTemplates.byId[templateId] = _objectSpread(_objectSpread({}, state.documentRequestTemplates.byId[templateId]), {}, {
      html
    });
  },
  [SET_DOCUMENT_REQUEST_EMAIL_TEMPLATE_DETAILS]: (state, {
    templateId,
    newTemplateInfo
  }) => {
    state.documentRequestTemplates.byId[templateId] = newTemplateInfo;
  },
  [REMOVE_DOCUMENT_REQUEST_EMAIL_TEMPLATE]: (state, {
    templateId
  }) => {
    var _context2;
    state.documentRequestTemplates.allIds = _filterInstanceProperty(_context2 = state.documentRequestTemplates.allIds).call(_context2, template => template !== templateId);
    Vue.delete(state.documentRequestTemplates.byId, templateId);
  },
  [SET_NEW_DOCUMENT_REQUEST_EMAIL_TEMPLATE]: (state, templateInfo) => {
    if (!templateInfo.id) return;
    state.documentRequestTemplates.byId = _objectSpread(_objectSpread({}, state.documentRequestTemplates.byId), {}, {
      [templateInfo.id]: templateInfo
    });
    state.documentRequestTemplates.allIds.push(templateInfo.id.toString());
  },
  [SET_DOCUMENT_REQUEST_LIST]: (state, {
    documentRequests,
    documentRequestList
  }) => {
    const normalizedDocumentRequestIds = [];
    const normalizedDocumentRequests = _reduceInstanceProperty(documentRequests).call(documentRequests, (acc, documentRequest) => {
      if (documentRequest.id) {
        acc[documentRequest.id] = documentRequest;
        normalizedDocumentRequestIds.push(documentRequest.id);
      }
      return acc;
    }, {});
    Vue.set(state.documentRequestLists.byId, documentRequestList.name, _objectSpread(_objectSpread({}, documentRequestList), {}, {
      documentRequests: uniq([...normalizedDocumentRequestIds, ...state.documentRequestLists.byId[documentRequestList.name].documentRequests])
    }));
    state.documentRequestLists.allIds = uniq([...state.documentRequestLists.allIds, documentRequestList.name]);
    Vue.set(state.documentRequests, "byId", _objectSpread(_objectSpread({}, state.documentRequests.byId), normalizedDocumentRequests));
  },
  [EMPTY_REQUEST_LIST]: (state, {
    documentRequestListName
  }) => {
    const documentRequestList = state.documentRequestLists.byId[documentRequestListName];
    for (const documentRequest of documentRequestList.documentRequests) {
      Vue.delete(state.documentRequests.byId, documentRequest);
    }
    documentRequestList.documentRequests = [];
  },
  [DELETE_REQUEST_LIST]: (state, {
    documentRequestListName
  }) => {
    var _context3;
    const documentRequestList = state.documentRequestLists.byId[documentRequestListName];
    for (const documentRequest of documentRequestList.documentRequests) {
      Vue.delete(state.documentRequests.byId, documentRequest);
    }
    Vue.delete(state.documentRequestLists.byId, documentRequestListName);
    state.documentRequestLists.allIds = _filterInstanceProperty(_context3 = state.documentRequestLists.allIds).call(_context3, list => list !== documentRequestListName);
  },
  [SET_DOCUMENT_REQUEST_CLASSIFICATION_DESCRIPTION]: (state, {
    documentRequestId,
    description
  }) => {
    Vue.set(state.documentRequests.byId[documentRequestId], "description", description);
  },
  [REMOVE_DOCUMENT_REQUEST_CLASSIFICATION]: (state, {
    documentRequestId,
    documentRequestListName
  }) => {
    const documentRequests = state.documentRequestLists.byId[documentRequestListName].documentRequests;
    state.documentRequestLists.byId[documentRequestListName].documentRequests = _filterInstanceProperty(documentRequests).call(documentRequests, id => id !== documentRequestId);
    delete state.documentRequests.byId[documentRequestId];
    if (isEmpty(state.documentRequestLists.byId[documentRequestListName].documentRequests) && !state.documentRequestLists.byId[documentRequestListName].draft) {
      var _context4;
      Vue.delete(state.documentRequestLists.byId, documentRequestListName);
      state.documentRequestLists.allIds = _filterInstanceProperty(_context4 = state.documentRequestLists.allIds).call(_context4, list => list !== documentRequestListName);
    }
  },
  [ADD_DOCUMENT_REQUEST_CLASSIFICATION]: (state, {
    documentRequestListName,
    documentRequests
  }) => {
    for (const documentRequest of documentRequests) {
      if (!documentRequest.id) return;
      Vue.set(state.documentRequests.byId, documentRequest.id, documentRequest);
      Vue.set(state.documentRequestLists.byId, documentRequestListName, _objectSpread(_objectSpread({}, state.documentRequestLists.byId[documentRequestListName]), {}, {
        documentRequests: uniq([...state.documentRequestLists.byId[documentRequestListName].documentRequests, documentRequest.id])
      }));
    }
  },
  [ADD_DOCUMENT_REQUEST_LIST]: (state, {
    documentRequestListName
  }) => {
    state.documentRequestLists.allIds.push(documentRequestListName);
    Vue.set(state.documentRequestLists.byId, documentRequestListName, {
      documentRequests: [],
      name: documentRequestListName
    });
  },
  [EDIT_REQUEST_LIST_DOCUMENT_DETAILS]: (state, {
    document
  }) => {
    Vue.set(state.sampleDocuments.byId, document.documentId, _objectSpread(_objectSpread({}, state.sampleDocuments.byId[document.documentId]), document));
  },
  [ADD_DOCUMENT_TO_REQUEST_CLASSIFICATION]: (state, {
    document,
    documentRequestId
  }) => {
    Vue.set(state.sampleDocuments.byId, document.documentId, document);
    const documentRequests = state.documentRequests.byId[documentRequestId];
    if (documentRequests.sampleDocuments) documentRequests.sampleDocuments.push(document.documentId);
  },
  [REMOVE_DOCUMENT_FROM_REQUEST_CLASSIFICATION]: (state, {
    documentId,
    documentRequestId
  }) => {
    var _documentRequests$sam;
    Vue.delete(state.sampleDocuments.byId, documentId);
    const documentRequests = state.documentRequests.byId[documentRequestId];
    documentRequests.sampleDocuments = ((_documentRequests$sam = documentRequests.sampleDocuments) == null ? void 0 : _filterInstanceProperty(_documentRequests$sam).call(_documentRequests$sam, id => id !== documentId)) || [];
  },
  [SET_DOCUMENT_TYPES]: (state, {
    byId,
    allIds
  }) => {
    state.documentTypes.allIds = uniq(allIds);
    Vue.set(state.documentTypes, "byId", byId);
  },
  [UPDATE_DOCUMENT_TYPE]: (state, {
    documentTypeId,
    description,
    title
  }) => {
    Vue.set(state.documentTypes.byId, documentTypeId, _objectSpread(_objectSpread({}, state.documentTypes.byId[documentTypeId]), {}, {
      description,
      title
    }));
  },
  [REMOVE_DOCUMENT_TYPE]: (state, {
    documentTypeId
  }) => {
    Vue.delete(state.documentTypes.byId, documentTypeId);
  },
  [ADD_DOCUMENT_TYPE]: (state, {
    documentTypeId,
    title,
    description = null,
    typeOrder
  }) => {
    Vue.set(state.documentTypes.byId, documentTypeId, {
      title,
      description,
      documentTypeId,
      typeOrder
    });
    state.documentTypes.allIds.push(documentTypeId);
  },
  [SET_DOCUMENT_TYPES_ORDER]: (state, {
    documentTypes
  }) => {
    const byId = state.documentTypes.byId;
    const updatedDocumentTypes = _reduceInstanceProperty(documentTypes).call(documentTypes, (acc, current) => {
      acc[current.id] = _objectSpread(_objectSpread({}, byId[current.id]), {}, {
        typeOrder: current.typeOrder
      });
      return acc;
    }, {});
    Vue.set(state.documentTypes, "byId", updatedDocumentTypes);
  },
  [SET_DOCUMENT_REQUESTS_ORDER]: (state, {
    documentsClassificationOrder,
    applicationId
  }) => {
    const byId = state.classifications.byApplication[applicationId].byId;
    const updatedDocumentRequests = _reduceInstanceProperty(documentsClassificationOrder).call(documentsClassificationOrder, (acc, current) => {
      acc[current.documentRequestId] = _objectSpread(_objectSpread({}, byId[current.documentRequestId]), {}, {
        customOrder: current.customOrder
      });
      return acc;
    }, {});
    Vue.set(state.classifications.byApplication[applicationId], "byId", updatedDocumentRequests);
  },
  [SET_DOCUMENT_LABEL]: (state, {
    label,
    isShared
  }) => {
    var _context5;
    const typeOfLabel = isShared ? "brokerageLabels" : "userLabels";
    Vue.set(state.labels[typeOfLabel].byId, label.id, label);
    if (!_includesInstanceProperty(_context5 = state.labels[typeOfLabel].allIds).call(_context5, label.id)) state.labels[typeOfLabel].allIds.push(label.id);
  },
  [SET_DOCUMENT_LABELS]: (state, {
    brokerageLabels,
    userLabels
  }) => {
    if (brokerageLabels) {
      Vue.set(state.labels.brokerageLabels, "byId", brokerageLabels.byId);
      Vue.set(state.labels.brokerageLabels, "allIds", brokerageLabels.allIds);
    }
    if (userLabels) {
      Vue.set(state.labels.userLabels, "byId", userLabels.byId);
      Vue.set(state.labels.userLabels, "allIds", userLabels.allIds);
    }
  },
  [ADD_DOCUMENT_LABEL]: (state, {
    applicationId,
    documentId,
    label
  }) => {
    var _state$documents$byAp, _state$documents$byAp2, _state$documents$byAp3, _state$documents$byAp4, _state$documents$byAp5, _state$documents$byAp6, _state$documents$byAp7, _state$documents$byAp8;
    if ((_state$documents$byAp = state.documents.byApplication) != null && (_state$documents$byAp2 = _state$documents$byAp[applicationId]) != null && (_state$documents$byAp3 = _state$documents$byAp2.byId[documentId]) != null && _state$documents$byAp3.labels) (_state$documents$byAp4 = state.documents.byApplication) == null ? void 0 : (_state$documents$byAp5 = _state$documents$byAp4[applicationId]) == null ? void 0 : (_state$documents$byAp6 = _state$documents$byAp5.byId[documentId]) == null ? void 0 : (_state$documents$byAp7 = _state$documents$byAp6.labels) == null ? void 0 : _state$documents$byAp7.push(label);else Vue.set((_state$documents$byAp8 = state.documents.byApplication[applicationId]) == null ? void 0 : _state$documents$byAp8.byId[documentId], "labels", [label]);
  },
  [DELETE_LABEL_TO_DOCUMENT]: (state, {
    applicationId,
    documentId,
    labelId
  }) => {
    var _state$documents$byAp9, _state$documents$byAp0, _state$documents$byAp1, _state$documents$byAp10, _state$documents$byAp11, _state$documents$byAp12;
    const index = (_state$documents$byAp9 = state.documents.byApplication[applicationId]) == null ? void 0 : (_state$documents$byAp0 = _state$documents$byAp9.byId[documentId]) == null ? void 0 : (_state$documents$byAp1 = _state$documents$byAp0.labels) == null ? void 0 : _findIndexInstanceProperty(_state$documents$byAp1).call(_state$documents$byAp1, label => label.id === labelId);
    if (!isNil(index)) (_state$documents$byAp10 = state.documents.byApplication[applicationId]) == null ? void 0 : (_state$documents$byAp11 = _state$documents$byAp10.byId[documentId]) == null ? void 0 : (_state$documents$byAp12 = _state$documents$byAp11.labels) == null ? void 0 : _spliceInstanceProperty(_state$documents$byAp12).call(_state$documents$byAp12, index, 1);
  },
  [DELETE_DOCUMENT_LABEL]: (state, {
    labelId,
    isShared
  }) => {
    var _context6, _context7;
    const typeOfLabel = isShared ? "brokerageLabels" : "userLabels";
    Vue.delete(state.labels[typeOfLabel].byId, labelId);
    _spliceInstanceProperty(_context6 = state.labels[typeOfLabel].allIds).call(_context6, _findIndexInstanceProperty(_context7 = state.labels[typeOfLabel].allIds).call(_context7, label => label === labelId), 1);
  },
  [SET_DOCUMENT_NEW_COMMENTS_NUMBER]: (state, {
    applicationId,
    documentId,
    number
  }) => {
    Vue.set(state.documents.byApplication[applicationId].byId[documentId], "nrOfNewComments", number);
  },
  [SET_EXTRACTED_VALUES]: (state, {
    result,
    documentId
  }) => {
    var _context8;
    const isExisting = _includesInstanceProperty(_context8 = state.extractedDocumentValues.allIds).call(_context8, documentId);
    if (!isExisting) state.extractedDocumentValues.allIds.push(documentId);
    Vue.set(state.extractedDocumentValues.byId, documentId, result);
  }
};
export default mutations;